export default "__VITE_ASSET__UCpqvRfp__"